class CartCount extends HTMLElement {
  constructor() {
    super();

    const setCount = (count) => {
      this.innerHTML = `
      <span aria-hidden="true">${count > 0 ? count : 0}</span>
      <span class="visually-hidden">${
        count === 1
          ? this.dataset.one
          : this.dataset.other.replace("[count]", count)
      }</span>`;
    };

    if (window.cartData?.item_count) {
      setCount(window.cartData.item_count);
    }

    document.addEventListener("cart:updated", (e) => {
      setCount(e.detail.cartData.item_count);
    });
  }
}

if (!customElements.get("cart-count")) {
  customElements.define("cart-count", CartCount);
}
